import type { MedicationPadItemType } from '@/components/Patient/components/PrescriptionPad';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const updatePrescriptionHistoryItemsToReissue: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (itemsToReissue: MedicationPadItemType[]) => void
> = (set) => (itemsToReissue) =>
  set(
    (state: PrescriptionAssistantSliceType) => {
      state.prescriptionAssistant.prescriptionHistory.itemsToReissue = itemsToReissue;
    },
    false,
    'prescriptionHistory/updatePrescriptionHistoryItemsToReissue',
  );
